import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import BookingsPage from "@/pages/BookingsPage";
import BookingFormPage from "@/pages/BookingFormPage";
import BookingDetailPage from "@/pages/BookingDetailPage";
import CalendarPage from "@/pages/CalendarPage";
import CustomersPage from "@/pages/CustomersPage";
import PaymentsPage from "@/pages/PaymentsPage";
import SettingsPage from "@/pages/SettingsPage";
import ImportPage from "@/pages/ImportPage";
import FlaggedJobsPage from "@/pages/FlaggedJobsPage";
import AuditLogPage from "@/pages/AuditLogPage";
import RunSheetPage from "@/pages/RunSheetPage";
import InvoicesPage from "@/pages/InvoicesPage";
import InvoiceDetailPage from "@/pages/InvoiceDetailPage";
import PayrollPage from "@/pages/PayrollPage";
import ReportsPage from "@/pages/ReportsPage";

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  return ["admin", "owner"].includes(user?.role) ? children : <Navigate to="/" replace />;
};

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route index element={<DashboardPage />} />
            <Route path="bookings" element={<BookingsPage />} />
            <Route path="bookings/new" element={<BookingFormPage />} />
            <Route path="bookings/import" element={<ImportPage />} />
            <Route path="bookings/flagged" element={<FlaggedJobsPage />} />
            <Route path="run-sheet" element={<RunSheetPage />} />
            <Route path="invoices" element={<AdminOnly><InvoicesPage /></AdminOnly>} />
            <Route path="invoices/:id" element={<AdminOnly><InvoiceDetailPage /></AdminOnly>} />
            <Route path="payroll" element={<AdminOnly><PayrollPage /></AdminOnly>} />
            <Route path="reports" element={<AdminOnly><ReportsPage /></AdminOnly>} />
            <Route path="audit" element={<AdminOnly><AuditLogPage /></AdminOnly>} />
            <Route path="bookings/:id" element={<BookingDetailPage />} />
            <Route path="bookings/:id/edit" element={<BookingFormPage />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="customers" element={<CustomersPage />} />
            <Route path="payments" element={<AdminOnly><PaymentsPage /></AdminOnly>} />
            <Route path="settings" element={<AdminOnly><SettingsPage /></AdminOnly>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
